// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__+SIaL","label":"SearchBar_label__0fMyJ","search":"SearchBar_search__n1hCQ","img":"SearchBar_img__ZxKpe","input":"SearchBar_input__roca3"};